// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__2t-Wy","active":"styles_active__2EF8x"};